<template>
  <global-dialog-card
    v-model="model"
    :title="$t('select_image')"
    :max-width="1000"
    hide-actions
  >
    <text-field
      :value="searchImage"
      @input="onSearchInput"
      :label="$t('search')"
      prepend-inner-icon="mdi-magnify"
    />
    <v-row>
      <v-col
        v-for="image in imagesFilter"
        :key="image.id"
        class="d-flex child-flex"
        cols="12"
        sm="6"
        md="4"
        xl="3"
      >
        <v-row>
          <v-col cols="12" class="pb-0">
            <v-img
              :src="
                conf.apiUrlBase +
                '/gallery/' +
                restaurantId +
                '/medium/' +
                image.name
              "
              @click="$emit('select-image', image)"
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5" />
                </v-row>
              </template>
            </v-img>
          </v-col>
          <v-col cols="12" class="pt-0 text-center">
            <div>{{ image.name | imageName }}</div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </global-dialog-card>
</template>

<script>
import conf from "@/config";
import menuService from "@/services/menu";
import hasSnackbar from "@/mixins/hasSnackbar";
import hasModel from "@/mixins/hasModel";

export default {
  name: "ImageGalleryDialog",
  mixins: [hasModel, hasSnackbar],
  props: {
    restaurantId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      conf: conf,
      images: [],
      imagesFilter: [],
      searchImage: "",
    };
  },
  created() {
    this.getImages();
  },
  methods: {
    onSearchInput(value) {
      this.searchImage = value;
      this.filterImages();
    },
    filterImages() {
      this.imagesFilter = this.images.filter((i) => i.name.includes(this.searchImage));
    },
    getImages() {
      menuService
        .getGalleryImages()
        .then((res) => {
          this.images = res.data;
          this.imagesFilter = res.data;
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_loading_images"));
        });
    },
  },
  filters: {
    imageName(name) {
      if (name) {
        const imageName = name.split(".");
        return imageName[0].replace("_", " ").replace("-", " ");
      }
    },
  },
};
</script>
